

import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant='filled' {...props} />;
});

const GlobalSnackbar = (props) => {
  const styledAlert = { width: '100%', display: 'flex', alignItems: 'center' };
  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={props.open}
      autoHideDuration={5000}
      onClose={props.onClose}
      message={props.message}>
      <Alert onClose={props.onClose} severity={props?.theme} sx={styledAlert}>
        {props.message}
      </Alert>
    </Snackbar>
  );
};

export default GlobalSnackbar;